function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
} 
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD', 
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const formatterWholeNum = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

class bdVariantSelects extends HTMLElement {
  constructor() {
    super(); 
    this.addEventListener('change', this.variantChange);
  }

  variantChange(event) {
    console.log(this, 'VARIANT THIS');
    console.log(event, 'VARIANT THIS EVENT');

    let newUrl =
      window.location.origin +
      window.location.pathname +
      `?variant=${event.target.value}`;
    history.pushState(null, '', newUrl);

    const container = this.closest('product-block');
    const variantId = event.target.value;
    //const variantData =  JSON.parse(this.querySelector('[data-variant-info]').textContent);
    container.querySelector('[name="id"]').value = variantId;

    this.updateAvailableMsg(variantId, container);
  }

  updateAvailableMsg(variantId, container) {
    const sectionId = 'bd-product-template';
    console.log(
      `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`,
      'FETCH URL'
    );
    fetch(
      `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`
    )
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newHTML = parser.parseFromString(html, 'text/html');
        const availablity = newHTML.querySelector('[data-available-block]');
        const form = newHTML.querySelector('product-form');
        container.querySelector('[data-available-block]').innerHTML =
          availablity.innerHTML;
       // container.querySelector('product-form').innerHTML = form.innerHTML;

        
        const addButtonUpdated = newHTML.querySelector('product-block [name="add"]');
        console.log('NEW ADD', addButtonUpdated);
        
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut, true, container
        );
       
      })
      .catch((error) => console.error('Error fetching section:', error));
  } 

  toggleAddButton(disable = true, text, modifyClass = true, container) {
    const productForm = container.querySelector('[action="/cart/add"]');
    console.log(productForm, 'Existing Form');
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[data-button-text]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('hide');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
          addButton.classList.remove('hide');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
}
customElements.define('bd-variants', bdVariantSelects);

// QUOTE FORM OPTIONS
const mirrorOptions = document.querySelectorAll('[data-mirror-option]');

mirrorOptions.forEach((option) => {
  option.addEventListener('change', function (event) {
    const choice = option.dataset.mirrorOption;

    if (event.target.checked) {
      mirrorOptions.forEach((option) => {
        if (option.dataset.mirrorOption == choice) {
          option.checked = true;
        }
      });
    } else {
      mirrorOptions.forEach((option) => {
        if (option.dataset.mirrorOption == choice) {
          option.checked = false;
        }
      });
    }
  });
});
